import React from "react";

const SvgBurger = props => <svg fill="none" viewBox="0 0 20 13" {...props}><defs /><path stroke="black" d="M0 .5h20M0 6.5h20M0 12.5h20" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyMCAxMyI+PGRlZnMvPjxwYXRoIHN0cm9rZT0iYmxhY2siIGQ9Ik0wIC41aDIwTTAgNi41aDIwTTAgMTIuNWgyMCIvPjwvc3ZnPg==";
export { SvgBurger as ReactComponent };